import { useState } from "react";
import { InterviewAdvanceSearchService } from "../../../services/InterviewAdvanceSearch";
import { InterviewExportButton } from "../InterviewExportButton";
import { useAdvanceSearchContext } from "./AdvanceSearchContextTest";
import SortedHeader from "../../../components/Tables/SortedHeader";
import moment from "moment";
import IconValid from "../../../layout/others/valid-check-icon.svg";
export default function ResultTab() {
  const {
    interviews,
    searchObject,
    setSearchObject,
    sort,
    t
  } = useAdvanceSearchContext();

  const [headers, setHeaders] = useState([
    { label: t(""), field: "CandidateStateColor" },
    {
      label: t("Full Name"),
      field: "FullName",
      style: { paddingLeft: "10px" }
    },
    { label: t("Phone"), field: "MobilePhoneNumber" },
    { label: t("Need Doc."), field: "IsForeingWithoutDoc" },
    { label: t("Job Role"), field: "JobRoleId" },
    { label: t("Tech Area"), field: "TechArea" },
    { label: t("Tech Role"), field: "TechRole" },
    { label: t("Availability"), field: "Availability" },
    { label: t("Expected Salary"), field: "SalaryExpected" },
    { label: t("Created Date"), field: "CreatedDate", sorted: true },
    { label: t("Modified Date"), field: "MOdifiedDate", sorted: true },
    { label: t("Technologies") }
  ]);

  const fileFormat = { pdf: 1, excel: 0 };

  function exportTo(format) {
    let fileName = "";
    if (format === fileFormat.excel) fileName = new Date() + ".xlsx";

    let searchObjectCopy = { ...searchObject };
    searchObjectCopy = formatRequest(searchObjectCopy);
    searchObjectCopy.format = format;
    InterviewAdvanceSearchService.export(searchObjectCopy, fileName);
  }

  function formatRequest(_searchObject) {
    let formated = { ..._searchObject };

    formated.skills = _searchObject.skills.map((skill) => skill.id);
    if (searchObject.personalSkills)
      formated.personalSkills = _searchObject.personalSkills.filter(
        (skill) => skill.rating > 0
      );
    formated.zones = _searchObject.zones.map((x) => x.id);
    formated.managerInterestId = formated.managerInterestId.map(
      (managerInterest) => managerInterest.id
    );
    formated.yearsOfExperienceOptions = formated.yearsOfExperienceOptions.map(
      (yearsOfExperience) => yearsOfExperience.id
    );
    formated.tags = formated.tags.map((tags) => tags.id);
    formated.languageLevels = formated.languageLevels.map(
      (languageLevel) => languageLevel.id
    );
    formated.seniorityLevels = formated.seniorityLevels.map(
      (seniorityLevels) => seniorityLevels.id
    );
    formated.jobRoles = formated.jobRoles.map((jobRole) => jobRole.id);

    if (formated.businessAreas)
      formated.businessAreas = formated.businessAreas.map(
        (businessArea) => businessArea.id
      );
    if (formated.candidateBusinessArea)
      formated.candidateBusinessArea = formated.candidateBusinessArea.map(
        (candidateBusinessArea) => candidateBusinessArea.id
      );

    return formated;
  }

  return (
    <>
      <div className="row">
        <div className="col-offset-10 text-end">
          <InterviewExportButton exportToFile={exportTo} />
        </div>
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <SortedHeader
              searchObject={searchObject}
              setSearchObject={setSearchObject}
              headers={headers}
              sort={sort}
              setHeaders={setHeaders}
            />
          </thead>
          <tbody>
            {interviews?.map((interview, index) => {
              let candidateStateColor = "";
              let tooltip = "";
              if (interview.interestTypeCode === "NCT") {
                candidateStateColor = "bl-red";
                tooltip = t("Manager interest do not hire");
              } else if (interview.interestTypeCode === "CD") {
                candidateStateColor = "bl-orange";
                tooltip = t("Manager interest direct hiring");
              }

              return (
                <tr
                  className={
                    interview.interestTypeCode === "CT"
                      ? "b  bg-success bg-opacity-10 "
                      : interview.interestTypeCode === "NCT"
                      ? "bg-notHiring"
                      : ""
                  }
                  key={index}
                  onClick={() => window.open(`view/${interview.id}`).focus()}
                  title={interview.interestTypeCode === "CT" && "Hired"}
                >
                  <td
                    title={t(tooltip)}
                    className={`candidate-state ${candidateStateColor}`}
                    style={{ width: "1%" }}
                  ></td>
                  <td style={{ paddingLeft: "10px" }}>{interview.fullName}</td>
                  <td>{interview.phoneNumber}</td>
                  <td className="text-center">
                    {interview.needDocumentation && (
                      <img src={IconValid} alt="valid" title={t("need")} />
                    )}
                  </td>
                  <td>{interview.jobRole}</td>
                  <td>{interview.techArea}</td>
                  <td>{interview.techRole}</td>
                  <td>{t(interview.availability)}</td>
                  <td>{interview.expectedSalary}</td>
                  <td>{moment(interview.createdDate).format("DD-MM-YYYY")}</td>
                  <td>{moment(interview.modifiedDate).format("DD-MM-YYYY")}</td>
                  <td>
                    {interview.skills.map((skill, index) => (
                      <span key={index} style={{ fontSize: 10 }}>
                        {" "}
                        {skill},
                      </span>
                    ))}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
